import Category from '@/models/Category'
import Api from '@/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: []
  },

  mutations: {
    setCategoryList(state, categories) {
      each(categories, category => {
        const exist = find(state.list, { id: category.id })
        if (!exist) {
          state.list.push(new Category(category))
        }
      })
    },

    clearCategoryList(state) {
      state.list = []
    }
  },

  actions: {
    async getCategories({ commit }, params) {
      const { data } = await Api.get(`jobs/categories?include[]=subcategories`)
      commit('setCategoryList', data.data)
    }
  }
}
